import useAuth from '../hooks/useAuth';
import {useEffect} from 'react';
import {useNavigate} from "react-router-dom";
import RequestApi from "../api/RequestApi";
import AuthApi from "../api/AuthApi";

const DirectPage= () => {

    const { setAuth, setRoles, setUser } = useAuth();
    const navigate = useNavigate();

    useEffect(() => {

        const queryParams = new URLSearchParams(window.location.search)
        const token = queryParams.get("token")
        const pid = queryParams.get("pid")

        console.log(pid, token);
        if (token && token !== '' && pid && pid !== '') {

            AuthApi.loginToken(token).then((data) => {
                if (data.status === 'success' && data.content.token) {
                    localStorage.setItem('token', data.content.token);
                    setAuth(true);
                    // set Roles
                    let roles = ['ROLE_USER'];
                    if (data.content.roles) {
                        roles = data.content.roles;
                        localStorage.setItem('roles', JSON.stringify(roles));
                        setRoles(roles);
                        let currentUser = {
                            id: data.content.id,
                            login: data.content.login,
                            name: data.content.name
                        }
                        localStorage.setItem('user', JSON.stringify(currentUser));
                        setUser(currentUser);
                        navigate('/cabinet/catalog/course/' + pid);
                    }
                } else {
                    navigate('/');
                }
            }).catch(error => {
                navigate('/');
            })

        } else {
            navigate('/');
        }


    }, [])

    return <>
        <div className={'py-10 text-center'}>
            Пожалуйста, ожидайте загрузки ...
        </div>
    </>

}

export default DirectPage;
